import { render, staticRenderFns } from "./SysHistograma.vue?vue&type=template&id=45df7ba1"
import script from "./SysHistograma.vue?vue&type=script&lang=js"
export * from "./SysHistograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports